import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPlay = (props) => /* @__PURE__ */ _jsx("span", { children: /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M1.6875 9C1.6875 4.96278 4.96278 1.6875 9 1.6875C13.0372 1.6875 16.3125 4.96278 16.3125 9C16.3125 13.0372 13.0372 16.3125 9 16.3125C4.96278 16.3125 1.6875 13.0372 1.6875 9ZM9 2.8125C5.5841 2.8125 2.8125 5.5841 2.8125 9C2.8125 12.4159 5.5841 15.1875 9 15.1875C12.4159 15.1875 15.1875 12.4159 15.1875 9C15.1875 5.5841 12.4159 2.8125 9 2.8125Z",
		fill: "white"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M7.60501 11.7577L11.6286 9.32697C11.6847 9.2928 11.7311 9.24477 11.7632 9.18752C11.7954 9.13026 11.8123 9.06569 11.8123 9.00001C11.8123 8.93434 11.7954 8.86977 11.7632 8.81251C11.7311 8.75525 11.6847 8.70723 11.6286 8.67306L7.60501 6.24236C7.54733 6.2078 7.48151 6.18922 7.41428 6.1885C7.34705 6.18778 7.28084 6.20496 7.22244 6.23827C7.16405 6.27159 7.11556 6.31984 7.08197 6.37807C7.04837 6.43631 7.03087 6.50243 7.03126 6.56966V11.4304C7.03087 11.4976 7.04837 11.5637 7.08197 11.622C7.11556 11.6802 7.16405 11.7284 7.22244 11.7618C7.28084 11.7951 7.34705 11.8122 7.41428 11.8115C7.48151 11.8108 7.54733 11.7922 7.60501 11.7577Z",
		fill: "white"
	})]
}) });
export default SvgPlay;
